import type { ID } from '@octopus-do/octopus-project-core'

export const toggleId = (id: ID, prev: ID[]) => {
  if (prev.includes(id)) {
    return prev.filter((item) => item !== id)
  }

  return [...prev, id]
}
